
const API_BASE_URL = process.env.REACT_APP_BACKEND_API;
const BASE_URL = `${API_BASE_URL}/api/admin/`;

const adminAuthService = {
  getToken: () => {
    try {
      const token = localStorage.getItem('admin_token');
      if (!token || token === 'undefined' || token === 'null' || token.trim() === '') {
        console.log('No valid token found in localStorage');
        return null;
      }
      return token;
    } catch (error) {
      console.error('Error retrieving token:', error);
      return null;
    }
  },

  isAuthenticated: () => {
    return !!adminAuthService.getToken();
  },

  validateToken: async () => {
    const token = adminAuthService.getToken();
    if (!token) {
      console.log('No token available for validation');
      return false;
    }

    try {
      // Log only a part of the token for security
      const tokenPreview = token.substring(0, 10) + '...' + token.substring(token.length - 5);
      console.log('Validating token:', tokenPreview);
      
      const response = await fetch(`${BASE_URL}validate-token/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies if any
      });

      // Detailed logging of the response
      console.log('Token validation response status:', response.status);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        console.error('Token validation failed:', response.status, errorData);
        
        // If token is invalid or expired, clear it
        if (response.status === 401) {
          adminAuthService.clearToken();
        }
        
        return false;
      }

      const userData = await response.json();
      console.log('Token validation successful. User data received.');
      return true;
    } catch (error) {
      console.error('Token validation error:', error.message);
      return false;
    }
  },

  clearToken: () => {
    try {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user_id');
      console.log('Auth tokens cleared');
    } catch (error) {
      console.error('Error clearing tokens:', error);
    }
  },

  logout: () => {
    adminAuthService.clearToken();
    window.location.href = '/admin/login';
  },

  authHeader: () => {
    const token = adminAuthService.getToken();
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  },
};

export default adminAuthService;